<template>
  <custom-dialog class="addPatient" :title="addPatientType == 'add' ? '新增患者' : '修改患者'" width="370px"
    v-if="visibleObj.addPatientDialog" :show-close="true" :visible="visibleObj.addPatientDialog"
    @close="dialogVisible('addPatientDialog')" @save="confirm">
    <div slot="content">
      <el-form :model="patientForm" :rules="rules" ref="patientForm" label-width="80px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="patientName">
          <el-input v-model.trim="patientForm.patientName" clearable
            :disabled="patientForm.realIdCard || patientForm.idCardText ? true : false"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard" :rules="realNameSwitch == '1' ? [{ required: true, message: '请输入身份证号', trigger: 'blur' }] : []">
          <el-input v-if="patientForm.idCardText" v-model.trim="patientForm.idCardText" disabled></el-input>
          <el-input v-else v-model.trim="patientForm.idCard" clearable></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="patientForm.sex">
            <el-radio label="0">男</el-radio>
            <el-radio label="1">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="年龄">
          <div class="age-warp">
            <el-input ref="year" maxlength="3" v-model.number="patientForm.year" @blur="computeBirthday"
              @input="validParamsNum($event, 'year')" @keyup.enter.native="$refs['month'].focus()"
              @keyup.right.native="$refs['month'].focus()">
              <template slot="append">岁</template>
            </el-input>
            <el-input class="month-warp" maxlength="2" ref="month" @input="validParamsNum($event, 'month')"
              v-model.number="patientForm.month" @blur="computeBirthday" @keyup.enter.native="$refs['birthday'].focus()"
              @keyup.right.native="$refs['birthday'].focus()">
              <template slot="append">月</template>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item label="生日" prop="birthday">
          <el-date-picker value-format="yyyy-MM-dd" class="birthday-warp" :picker-options="pickerOptions"
            @change="$computeAge(patientForm.birthday, patientForm)" v-model="patientForm.birthday" type="date"
            placeholder="请选择生日">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input maxlength="11" v-model="patientForm.phone" clearable @input="getInfoByPhone"></el-input>
        </el-form-item>
        <el-form-item label="家庭住址" prop="addressRegion">
          <el-cascader style="width:100%" v-model="patientForm.addressRegion" placeholder="请选择省市区" :props="regionProps"
            :options="addressOptions" filterable clearable />
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="patientForm.address" placeholder="请输入详细地址"></el-input>
        </el-form-item>
        <div class="other_warp" v-if="addPatientType != 'edit' && !isHasRelation">
          <el-form-item label="推荐" class="source_warp">
            <el-select v-model="patientForm.sourceId" placeholder="请选择" class="width100" :disabled="isHasRelation">
              <el-option v-for="item in sourceConfigList" :key="item.id" :label="item.sourceName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="referrer_warp" v-if="[9, 10, 11].includes(patientForm.sourceId)">
            <el-select v-if="patientForm.sourceId == 10" v-model="patientForm.referrerDoctorId" filterable remote
              reserve-keyword placeholder="选择医生" :remote-method="getSourceDoctorList" :disabled="isHasRelation">
              <el-option v-for="item in doctorReferrerOptions" :key="item.doctorId" :label="item.doctorName"
                :value="item.doctorId">
              </el-option>
            </el-select>
            <el-select v-if="patientForm.sourceId == 11" v-model="patientForm.referrerUserId" filterable remote
              reserve-keyword placeholder="选择员工" :remote-method="getSourceUserList" :disabled="isHasRelation">
              <el-option v-for="item in userOptions" :key="item.userId" :label="item.nickName" :value="item.userId">
              </el-option>
            </el-select>
            <el-input v-if="patientForm.sourceId == 9" :disabled="isHasRelation"
              v-model.number="patientForm.referrerPhone" maxlength="11" placeholder="推荐人号码"></el-input>
          </el-form-item>
        </div>

      </el-form>
    </div>
  </custom-dialog>
</template>

<script>
import customDialog from './customDialog/CustomDialog.vue'
import { patientAdd, patientEdit, patientInfo } from '../api/patient'
import { isNull, validParams, debounce } from '@/utils/validateBase'
import { Utils } from '@/utils/utils'
import { validatePhone, positiveNum } from "@/utils/regexp" // 自定义验证
import { doctorList, doctorInfo } from "@/api/doctor"; // 医生列表请求
import { getInfoByPhone } from "@/api/member"; // 医生列表请求
import { userList, userInfo } from "@/api/user"; // 医生列表请求
import { CommonDTO } from '@/DTO/index'
import { validateIdCard } from '@/utils/regexp'
import { historyList } from '@/api/history'
import { provincesList } from "@/api/region"; // 获取区域请求
import { deptInfo } from '@/api/hospital'
export default {
  name: 'addPatient',

  // 定义引入的组件
  components: { customDialog },
  props: {
    visibleObj: {
      type: Object,
      default: {}
    },
    title: {
      type: String,
      default: '新增患者'
    },
    patientInfo: {
      type: Object,
      default: () => { return {} }
    },
    addPatientType: {
      type: String,
      default: 'add'
    },
    patientTemporaryMap: {
      type: Object,
      default: () => {
        return {
          name: '',
          phone: ''
        }
      }
    }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      rules: {
        patientName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        sex: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        month: [
          { min: 0, max: 11, message: '请输入0-11的数字', trigger: 'blur' }
        ],
        idCard: [{ validator: validateIdCard, trigger: 'blur' }],
      },
      patientForm: {
        birthday: '',
        patientName: '',
        phone: '',
        sex: '0',
        source: '平台',
        year: '',
        month: '',
        referrer: '',
        referrerDoctorId: '',
        referrerUserId: '',
        referrerPhone: '',
        sourceId: '',
        idCard: '',
        addressRegion: []
      },
      sourceConfigList: [],
      doctorReferrerOptions: [],
      isHasRelation: false,
      userOptions: [],
      addressOptions: [],
      regionProps: { label: "provincesName", value: "provincesId" }, // 区域选择配置
      realNameSwitch: null,
    }
  },
  //变量监听
  watch: {
    visibleObj: {
      deep: true,
      immediate: true,
      handler() {
        if (!isNull(this.patientInfo.patientId) && this.addPatientType == 'edit') {
          // this.patientForm.patientId = this.patientInfo.patientId
          // this.patientForm.patientName = this.patientInfo.patientName
          // this.patientForm.phone = this.patientInfo.phone
          // this.patientForm.sex = this.patientInfo.sex
          // this.patientForm.year = this.patientInfo.year
          // this.patientForm.birthday = Utils.timeFormat(this.patientInfo.birthday, 'yyyy-MM-DD')
          // this.patientForm.month = this.patientInfo.month
          // this.patientForm.idCard = this.patientInfo.idCard
          // this.patientForm.realIdCard = this.patientInfo.realIdCard
          // this.patientForm.idCardText = isNull(this.patientInfo.idCard) ? '' : this.patientForm.idCard.slice(0, 6) + '********' + this.patientForm.idCard.slice(-4)
          // if (this.patientInfo.province && this.patientInfo.city && this.patientInfo.region) {
          //   this.patientForm.addressRegion = [Number(this.patientInfo.province), Number(this.patientInfo.city), Number(this.patientInfo.region)]
          //   this.patientForm.provinceName = this.patientInfo.provinceName
          //   this.patientForm.cityName = this.patientInfo.cityName
          //   this.patientForm.regionName = this.patientInfo.region
          // }
          // this.patientForm.address = this.patientInfo.address
          this.getPatientInfo(this.patientInfo.patientId)
        } else {
          this.patientForm = {
            birthday: '',
            patientName: '',
            phone: '',
            sex: '0',
            source: '平台',
            year: '',
            month: '',
            referrer: '',
            referrerDoctorId: '',
            referrerUserId: '',
            referrerPhone: '',
            sourceId: '',
            idCard: '',
            idCardText: '',
            realIdCard: '',
            addressRegion: [],
            provinceName: '',
            cityName: '',
            regionName: '',
            address: '',
          }
        }
      },
    }
  },
  // 页面初始化
  async created() {
    this.getProvincesList(); // 请求区域列表
    let sourceConfigList = await CommonDTO.getSourceConfig()
    this.sourceConfigList = sourceConfigList && sourceConfigList.filter(item => item.showType == '2')

    if (!['', null, undefined].includes(this.patientTemporaryMap.name)) {
      this.patientForm.patientName = this.patientTemporaryMap.name
    }
    if (!['', null, undefined].includes(this.patientTemporaryMap.phone)) {
      this.patientForm.phone = this.patientTemporaryMap.phone
    }
    this.getDeptInfo(this.patientInfo.deptId)
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    async getPatientInfo(id) {
      let { code, data } = await patientInfo(id)
      if (code == 200) {
        this.patientForm = {
          ...data,
          year: data.age,
          month: data.ageMth,
          idCardText: isNull(data.idCard) ? '' : data.idCard.slice(0, 6) + '********' + data.idCard.slice(-4)
        }
        if (data.province && data.city && data.region) {
          this.patientForm.addressRegion = [Number(data.province), Number(data.city), Number(data.region)]
          this.patientForm.provinceName = data.provinceName
          this.patientForm.cityName = data.cityName
          this.patientForm.regionName = data.region
        }
        this.getInfoByPhone()
      }
    },
    // 请求所有区域列表列表
    async getProvincesList() {
      let { rows, code } = await provincesList();
      if (code == 200) this.listToTree(rows);
    },
    // 链式结构转树形结构
    listToTree(list) {
      // 省份列表
      list.forEach(item => { if (item.type == "0") this.addressOptions.push(item) });
      // 城市列表
      list.forEach(item => {
        if (item.type == "1") {
          this.addressOptions.forEach(items => {
            if (item.parentId == items.provincesId) items.children.push(item);
          });
        }
      });
      // 区/县列表
      list.forEach(item => {
        if (item.type == "2") {
          this.addressOptions.forEach(items => {
            items.children.forEach(itemm => {
              if (item.parentId == itemm.provincesId) itemm.children.push(item);
            });
          })
        }
      });
      // 范围列表
      list.forEach(item => {
        if (item.type == "3") {
          item.children = null
          this.addressOptions.forEach(items => {
            items.children.forEach(itemm => {
              itemm.children.forEach(itemn => {
                if (item.parentId == itemn.provincesId) itemn.children.push(item);
              })
            });
          })
        }
      });
      // 没有第四级的将第三级children设置为null
      this.addressOptions.forEach(items => {
        items.children.forEach(itemm => {
          itemm.children.forEach(itemn => {
            if (itemn.children.length == 0) itemn.children = null;
          })
        });
      })
    },
    /**
     * 取消
     */
    cancel() {
      this.$emit('colseAddPaient')
    },
    validParamsNum(val, type) {
      if (isNull(val)) return
      let bol = validParams(val, positiveNum, '请输入正整数')
      if (!bol) {
        if (type == 'year') this.patientForm.year = ''
        if (type == 'month') this.patientForm.month = ''
      }
    },
    // 计算生日
    computeBirthday() {
      this.patientForm.birthday = this.$computeBirthday(this.patientForm.year, this.patientForm.month);
    },
    /**
   * 确认
   */
    confirm() {
      if (this.patientForm.sourceId == 9) {
        this.patientForm.referrer = this.patientForm.referrerPhone
      } else if (this.patientForm.sourceId == 10) {
        this.patientForm.referrer = this.patientForm.referrerDoctorId
      } else if (this.patientForm.sourceId == 11) {
        this.patientForm.referrer = this.patientForm.referrerUserId
      }
      if (this.patientForm.addressRegion && this.patientForm.addressRegion.length > 0) {
        this.patientForm.province = this.patientForm.addressRegion[0]
        this.patientForm.city = this.patientForm.addressRegion[1]
        this.patientForm.region = this.patientForm.addressRegion[2]
        this.patientForm.provinceName = this.getAddressName(this.patientForm.addressRegion).provinceName
        this.patientForm.cityName = this.getAddressName(this.patientForm.addressRegion).cityName
        this.patientForm.regionName = this.getAddressName(this.patientForm.addressRegion).regionName
      }
      this.$refs.patientForm.validate((valid) => {
        if (valid) {
          if (isNull(this.patientForm.patientId)) {
            patientAdd(this.patientForm).then(res => {
              if (res.code == 200) {
                if (res.data && res.data.exists) {
                  this.$alert(`<div>患者已存在（身份证号码一致）</div><div>患者姓名：${this.patientForm.patientName}</div><div>患者手机号：${this.patientForm.phone}</div>`, '提示', {
                    dangerouslyUseHTMLString: true
                  });
                } else {
                  let obj = { ...res.data, referrer: this.patientForm.referrer, sourceId: this.patientForm.sourceId, addPatientType: 'add' }
                  this.$emit('addPatientComfirm', obj)
                }
              }
            })
          } else {
            patientEdit(this.patientForm).then(res => {
              if (res.code == 200) {
                if (res.data && res.data.exists) {
                  this.$alert(`<div>患者已存在（身份证号码一致）</div><div>患者姓名：${this.patientForm.patientName}</div><div>患者手机号：${this.patientForm.phone}</div>`, '提示', {
                    dangerouslyUseHTMLString: true
                  });
                } else {
                  this.$emit('addPatientComfirm', { ...res.data, addPatientType: 'edit' })
                }
              }
            })
          }
        }
      });
    },
    /**
     * 关闭
     */
    dialogVisible(name) {
      this.$emit("close", name);
    },
    async getSourceDoctorList(value) {
      let params = {
        pageNum: 1,
        pageSize: 100,
        status: 0,
        deptId: 0,
        doctorName: value
      }
      let { code, rows } = await doctorList(params)
      if (code == 200) {
        this.doctorReferrerOptions = rows
      }
    },
    async getSourceUserList(value) {
      let params = {
        pageNum: 1,
        pageSize: 100,
        nickName: value
      }
      let { code, rows } = await userList(params)
      if (code == 200) {
        this.userOptions = rows
      }
    },
    //获取医生详情
    async getDoctorInfo(id) {
      if (isNull(id)) return
      let { code, data } = await doctorInfo(id)
      if (code == 200 && !isNull(data)) {
        this.doctorReferrerOptions.push({
          doctorId: data.doctorId,
          doctorName: data.doctorName
        })
      }
    },
    async getUserInfo(id) {
      if (isNull(id)) return
      let { code, data } = await userInfo(id)
      if (code == 200 && !isNull(data.data)) {
        this.userOptions.push({
          userId: data.data.userId,
          nickName: data.data.nickName
        })
      }
    },

    getInfoByPhone: debounce(async function () {
      if (isNull(this.patientForm.phone)) {
        this.isHasRelation = false
        this.patientForm.sourceId = ''
        this.patientForm.referrerPhone = ''
        this.patientForm.referrerDoctorId = ''
        this.patientForm.referrerUserId = ''
        this.patientForm.referrer = ''
        return
      }
      let { code, data } = await getInfoByPhone({ phone: this.patientForm.phone })
      if (code == 200 && !isNull(data)) {
        this.isHasRelation = !isNull(data.sourceId)
        this.patientForm.sourceId = data.sourceId && Number(data.sourceId)
        if (!isNull(data.sourceId) && !isNull(data.referrer) && data.sourceId == 9) {
          this.patientForm.referrerPhone = data.referrer
        }
        if (!isNull(data.sourceId) && !isNull(data.referrer) && data.sourceId == 10) {
          this.patientForm.referrerDoctorId = data.referrer && Number(data.referrer)
          this.getDoctorInfo(data.referrer)
        }
        if (!isNull(data.sourceId) && !isNull(data.referrer) && data.sourceId == 11) {
          this.patientForm.referrerUserId = data.referrer && Number(data.referrer)
          this.getUserInfo(data.referrer)
        }
      } else {
        this.isHasRelation = false
        this.patientForm.sourceId = ''
        this.patientForm.referrerPhone = ''
        this.patientForm.referrerDoctorId = ''
        this.patientForm.referrerUserId = ''
        this.patientForm.referrer = ''
      }
    }, 300),

    //获取省市区名称
    getAddressName(addressRegion) {
      const addressName = {
        provinceName: '',
        cityName: '',
        regionName: ''
      }
      if (isNull(addressRegion)) return addressName
      const regionIds = Array.isArray(addressRegion) ? addressRegion : [addressRegion]
      const nameKeys = ['provinceName', 'cityName', 'regionName']
      let options = this.addressOptions
      regionIds.slice(0, nameKeys.length).forEach((regionId, index) => {
        const region = (options || []).find(item => String(item.provincesId) === String(regionId))
        if (!region) return
        addressName[nameKeys[index]] = region.provincesName
        options = region.children
      })
      return addressName
    },

    async getDeptInfo(id) {
      if (isNull(id)) return
      let { code, data } = await deptInfo(id)
      if (code == 200 && !isNull(data)) {
        this.realNameSwitch = data.realNameSwitch
      }
    },
  },
}
</script>
<style lang="less" scoped>
::v-deep .el-form-item__label:before {
  // display: none;
}

/deep/.el-input__inner {
  border: 1px solid #DCDFE6 !important;
  padding-left: 16px !important;
}

.age-warp {
  display: flex;

  /deep/.el-input__inner {
    border-right: none !important;
  }

  /deep/.el-input-group__append {
    border-right: none !important;
    border-radius: 0 4px 4px 0;
    background: #fff;

    &:last-child {
      border-right: 1px solid #DCDFE6 !important;
    }
  }

  .month-warp {
    margin-left: 8px;

    /deep/.el-input__inner {
      border-radius: 0;
    }
  }
}

.birthday-warp {
  width: 100%;

  /deep/.el-input__inner {
    padding-left: 30px !important;
  }
}

.other_warp {
  display: flex;

  .source_warp {
    width: 100%;
  }

  .referrer_warp {
    /deep/.el-form-item__content {
      margin-left: 8px !important;
    }
  }
}
</style>
